export const SCENE7_BASE_URLS = {
    IMAGE: 'https://s7d2.scene7.com/is/image/PetSmart',
    VIDEO: 'https://s7d2.scene7.com/is/content/PetSmart',
};

export const PICTURES = {
    NOT_FOUND: {
        ALT_TEXT: '404 Dog',
        SRC: 'https://images.petsmartassets.com/is/image/PetSmart/WEB-2371948-Aug24_404Page_Replatform_DT',
    },
};

export const SUPPORT_PHONE_NUMBER = {
    FORMATTED: '1 (888) 839-9638',
    RAW: '18888399638',
};

export const STORE_NUMBER = {
    STERLING_VA: 453,
    NIAGARA_FALLS: 2234,
};

export const VELOCITY_STORE_DELETED_ATTEMPT_FIX_NUM = 6;

export const PROFILE_DATA = {
    PROFILE: 'profile',
    ADDRESSES: 'addresses',
    PAYMENTS: 'payments',
    APPOINTMENTS: 'appointments',
    PACKAGES: 'packages',
};

export const AUTOSHIP_CONST = {
    OPTIONS: [
        {
            label: '2 weeks',
            value: '2_2',
        },
        {
            label: '3 weeks',
            value: '3_2',
        },
        {
            label: '4 weeks',
            value: '4_2',
        },
        {
            label: '6 weeks',
            value: '6_2',
        },
        {
            label: '8 weeks',
            value: '8_2',
        },
        {
            label: '3 months',
            value: '3_3',
        },
        {
            label: '4 months',
            value: '4_3',
        },
        {
            label: '6 months',
            value: '6_3',
        },
        {
            label: '9 months',
            value: '9_3',
        },
    ],
    FREQUENCY_DROPDOWN_LABEL: 'Choose Frequency',
    FREQUENCY_LABEL: 'Frequency',
    QUANTITY_DROPDOWN_LABEL: 'Quantity',
    ADD_BTN_AUTOSHIP: 'Add for autoship',
    DEFAULT_OPTION: '4_2',
    NOT_AVAIL_MSG: 'Not available for this item',
    AVAIL_MSG: 'Save on recurring orders',
    DRAWER_LINK_TEXT: 'Learn more',
    ADD_TO_AUTOSHIP_TEXT: 'Add to autoship',
    ADDED_TO_AUTOSHIP_TEXT: 'Added to autoship',
    ONE_TIME_LABEL: 'One-time',
    ONE_TIME_VALUE: 'one_time',
};
